const voivodeships_id_value = [
  {
    const: 1,
    title: 'dolnośląskie'
  },
  {
    const: 2,
    title: 'kujawsko-pomorskie'
  },
  {
    const: 3,
    title: 'lubelskie'
  },
  {
    const: 4,
    title: 'lubuskie'
  },
  {
    const: 5,
    title: 'łódzkie'
  },
  {
    const: 6,
    title: 'małopolskie'
  },
  {
    const: 7,
    title: 'mazowieckie'
  },
  {
    const: 8,
    title: 'opolskie'
  },
  {
    const: 9,
    title: 'podkarpackie'
  },
  {
    const: 10,
    title: 'podlaskie'
  },
  {
    const: 11,
    title: 'pomorskie'
  },
  {
    const: 12,
    title: 'śląskie'
  },
  {
    const: 13,
    title: 'świętokrzyskie'
  },
  {
    const: 14,
    title: 'warmińsko-mazurskie'
  },
  {
    const: 15,
    title: 'wielkopolskie'
  },
  {
    const: 16,
    title: 'zachodniopomorskie'
  }
];

const voivodeships = [
  'dolnośląskie',
  'kujawsko-pomorskie',
  'lubelskie',
  'lubuskie',
  'łódzkie',
  'małopolskie',
  'mazowieckie',
  'opolskie',
  'podkarpackie',
  'podlaskie',
  'pomorskie',
  'śląskie',
  'świętokrzyskie',
  'warmińsko-mazurskie',
  'wielkopolskie',
  'zachodniopomorskie'
];

export const schema = {
  type: 'object',
  required: [
    'nip',
    'a_nip',
    'pesel',
    'place',
    'taxID',
    'a_city',
    'county',
    'income',
    'street',
    'a_email',
    'a_pesel',
    'commune',
    'kinship',
    'retired',
    'student',
    'a_street',
    'bankName',
    'lastName',
    'postcode',
    'vacation',
    'pensioner',
    'taxOffice',
    'a_lastName',
    'a_postcode',
    'clientType',
    'postOffice',
    'unemployed',
    'firstName',
    'a_firstName',
    'citizenship',
    'companyName',
    'dateOfBirth',
    'a_dateOfBirth',
    'houseNumber',
    'laborOffice',
    'unpaidLeave',
    'voivodeship',
    'accountOwner',
    'a_houseNumber',
    'accountNumber',
    'partnerStatus',
    'a_accountNumber',
    'disabilityLevel',
    'runningBusiness',
    'studentLastYear',
    'nationalHealthFund',
    'certificateDisability',
    'retirementInsurance',
    'jobFrom',
    'jobTo',
    'contractFrom',
    'contractTo',
    'otherReason',
    'otherFrom',
    'otherTo',
    'studentType'
  ],
  properties: {
    nip: {
      type: 'string'
    },
    a_nip: {
      type: 'string'
    },
    jobTimeIndefinite: {
      type: 'boolean'
    },
    jobTo: {
      type: 'string',
      format: 'date'
    },
    pesel: {
      type: 'string'
    },
    place: {
      type: 'string'
    },
    taxID: {
      enum: ['Pesel', 'NIP'],
      type: 'string'
    },
    a_city: {
      type: 'string'
    },
    cardTo: {
      type: 'string',
      format: 'date'
    },
    county: {
      type: 'string'
    },
    income: {
      enum: ['Mniejszy', 'Równy (lub większy)'],
      type: 'string',
      description:
        'Jeżeli jestem objęty ubezpieczeniem emerytalnym i rentowym, o którym mowa w pkt 9 wyżej, to dodatkowo oświadczam, że mój łączny miesięczny dochód brutto z tamtego tytułu jest MNIEJSZY / RÓWNY (lub WIĘKSZY) od wysokości minimalnego wynagrodzenia obowiązującego w danym roku (które w okresie styczeń-czerwiec 2023 r. wynosi 3490 zł brutto, a w okresie lipiec-grudzień 2023 r. wynosi 3600 zł brutto).'
    },
    street: {
      type: 'string'
    },
    a_email: {
      type: 'string',
      format: 'email'
    },
    a_pesel: {
      type: 'string'
    },
    commune: {
      type: 'string'
    },
    jobFrom: {
      type: 'string',
      format: 'date'
    },
    kinship: {
      type: 'string',
      description:
        '(W polu wyżej należy wskazać stopień pokrewieństwa ze Zleceniodawcą, jeżeli jest on osobą fizyczną, z którą pozostajesz w relacji pokrewieństwa. Wpisz NIE DOTYCZY w każdym innym przypadku - czyli przykładowo w sytuacji, gdy Zleceniodawcą jest spółka, inna jednostka organizacyjna lub prawna albo gdy nie jesteś w relacji pokrewieństwa z osoba fizyczną zatrudniającą Ciebie)'
    },
    otherTo: {
      type: 'string',
      format: 'date'
    },
    retired: {
      enum: ['TAK', 'NIE'],
      type: 'string'
    },
    student: {
      enum: ['TAK', 'NIE'],
      type: 'string',
      description:
        'Jeśli TAK, proszę okazać ksero legitymacji oraz zapoznać się i wypełnić załącznik nr 1 do kwestionariusza.'
    },
    a_street: {
      type: 'string'
    },
    bankName: {
      type: 'string'
    },
    cardFrom: {
      type: 'string',
      format: 'date'
    },
    lastName: {
      type: 'string'
    },
    postcode: {
      type: 'string'
    },
    vacation: {
      type: 'string'
    },
    firstName: {
      type: 'string'
    },
    otherFrom: {
      type: 'string',
      format: 'date'
    },
    pensioner: {
      enum: ['TAK', 'NIE'],
      type: 'string'
    },
    taxOffice: {
      type: 'string',
      description:
        '(Właściwy dla podatnika Urząd skarbowy powinien być zgodny z jego adresem zamieszkania. Dlatego wskazany Urząd zostanie zweryfikowany z tym adresem, a jeżeli nie wskażesz Urzędu to zostanie on ustalony przez Zleceniodawcę na podstawie podanego adresu zamieszkania)'
    },
    a_lastName: {
      type: 'string'
    },
    a_postcode: {
      type: 'string'
    },
    cardNumber: {
      type: 'string'
    },
    clientType: {
      enum: ['Osoba fizyczna', 'Firma'],
      type: 'string'
    },
    contractTo: {
      type: 'string',
      format: 'date'
    },
    familyName: {
      type: 'string'
    },
    graduation: {
      type: 'string',
      format: 'date'
    },
    postOffice: {
      type: 'string'
    },
    unemployed: {
      enum: ['TAK', 'NIE'],
      type: 'string'
    },
    a_firstName: {
      type: 'string'
    },
    citizenship: {
      type: 'string'
    },
    companyName: {
      type: 'string'
    },
    dateOfBirth: {
      type: 'string',
      format: 'date'
    },
    houseNumber: {
      type: 'string'
    },
    laborOffice: {
      type: 'string',
      description:
        'a ponadto przyjmuję do wiadomości zobowiązuję się do zawiadomienia ww. urzędu o zawarciu umowy ze Zleceniodawcą w terminie 5 dni od podpisania tej umowy.'
    },
    otherReason: {
      type: 'string'
    },
    unpaidLeave: {
      enum: ['Pozostaję', 'Nie pozostaję'],
      type: 'string'
    },
    voivodeship: {
      enum: voivodeships,
      type: 'string'
    },
    accountOwner: {
      type: 'string'
    },
    contractFrom: {
      type: 'string',
      format: 'date'
    },
    placeOfBirth: {
      type: 'string'
    },
    a_dateOfBirth: {
      type: 'string',
      format: 'date'
    },
    a_houseNumber: {
      type: 'string'
    },
    accountNumber: {
      type: 'string'
    },
    partnerStatus: {
      enum: ['TAK', 'NIE'],
      type: 'string'
    },
    a_placeOfBirth: {
      type: 'string'
    },
    a_accountNumber: {
      type: 'string'
    },
    disabilityLevel: {
      type: 'string'
    },
    retiredNumber: {
      type: 'string'
    },
    pensionerNumber: {
      type: 'string'
    },
    runningBusiness: {
      enum: ['TAK', 'NIE'],
      type: 'string'
    },
    seriesAndNumber: {
      type: 'string',
      description:
        '(Jeżeli nie posiadasz numerów PESEL albo NIP to podaj rodzaj i numer dokumentu potwierdzającego tożsamość, a jeżeli posiadasz PESEL albo NIP to wpisz NIE DOTYCZY)'
    },
    studentLastYear: {
      enum: ['Jestem', 'Nie jestem'],
      type: 'string'
    },
    registered_place: {
      type: 'string'
    },
    registered_county: {
      type: 'string'
    },
    registered_street: {
      type: 'string'
    },
    nationalHealthFund: {
      type: 'string',
      description:
        '(Właściwy dla ubezpieczonego Oddziału Narodowego Funduszu Zdrowia powinien być zgodny z jego adresem zamieszkania – dlatego wskazany Oddział zostanie zweryfikowany z tym adresem, a jeżeli nie podasz danych Oddziału zostanie on ustalone właśnie na podstawie podanego adresu zamieszkania)'
    },
    registered_commune: {
      type: 'string'
    },
    registered_postcode: {
      type: 'string'
    },
    retirementInsurance: {
      enum: ['Jestem', 'Nie jestem'],
      type: 'string'
    },
    correspondence_place: {
      type: 'string'
    },
    certificateDisability: {
      enum: ['Posiadam', 'Nie posiadam'],
      type: 'string'
    },
    correspondence_county: {
      type: 'string'
    },
    correspondence_street: {
      type: 'string'
    },
    registered_postOffice: {
      type: 'string'
    },
    correspondence_commune: {
      type: 'string'
    },
    registered_houseNumber: {
      type: 'string'
    },
    registered_voivodeship: {
      enum: voivodeships,
      type: 'string'
    },
    correspondence_postcode: {
      type: 'string'
    },
    correspondence_postOffice: {
      type: 'string'
    },
    correspondence_houseNumber: {
      type: 'string'
    },
    correspondence_voivodeship: {
      enum: voivodeships,
      type: 'string'
    },
    studentType: {
      enum: [
        'Student',
        'Uczeń'
      ],
      type: 'string'
    },
    fromTitle: {
      type: 'array',
      items: {
        enum: [
          'Stosunku pracy w innym zakładzie pracy',
          'Wykonywania usług w ramach umów zlecenia',
          'Prowadzenia pozarolniczej działalności gospodarczej na własne nazwisko',
          'Statusu wspólnika spółki osobowej',
          'Inny'
        ],
        type: 'string'
      },
      uniqueItems: true
    }
  },
  getInitData: [
    {
      name: 'voivodeship',
      fields: [
        'voivodeship',
        'registered_voivodeship',
        'correspondence_voivodeship'
      ]
    }
  ]
};

export const uischema = {
  type: 'VerticalLayout',
  elements: [
    {
      type: 'Group',
      label: 'Dane personalne',
      elements: [
        {
          type: 'HorizontalResponsive',
          elements: [
            {
              type: 'Control',
              label: 'Imię',
              scope: '#/properties/firstName'
            },
            {
              type: 'Control',
              label: 'Nazwisko',
              scope: '#/properties/lastName'
            }
          ]
        },
        {
          type: 'HorizontalResponsive',
          elements: [
            {
              type: 'Control',
              label: 'Data urodzenia',
              scope: '#/properties/dateOfBirth',
              options: {
                dateFormat: 'DD-MM-YYYY'
              }
            },
            {
              type: 'Control',
              label: 'Miejsce urodzenia',
              scope: '#/properties/placeOfBirth'
            }
          ]
        },
        {
          type: 'HorizontalResponsive',
          elements: [
            {
              type: 'Control',
              label: 'Nazwisko rodowe',
              scope: '#/properties/familyName'
            },
            {
              type: 'Control',
              label: 'Obywatelstwo',
              scope: '#/properties/citizenship'
            }
          ]
        },
        {
          type: 'Control',
          label: 'Stopień pokrewieństwa ze zleceniodawcą',
          scope: '#/properties/kinship',
          options: {
            showUnfocusedDescription: true
          }
        }
      ]
    },
    {
      type: 'Group',
      label: 'Dane identyfikacyjne',
      elements: [
        {
          rule: {
            effect: 'HIDE',
            condition: {
              scope: '#/properties/seriesAndNumber',
              schema: {
                type: 'string',
                minLength: 1
              }
            }
          },
          type: 'VerticalLayout',
          elements: [
            {
              rule: {
                effect: 'HIDE',
                condition: {
                  scope: '#/properties/nip',
                  schema: {
                    type: 'string',
                    minLength: 1
                  }
                }
              },
              type: 'Control',
              label: 'Pesel',
              scope: '#/properties/pesel'
            }
          ]
        },
        {
          rule: {
            effect: 'HIDE',
            condition: {
              scope: '#/properties/seriesAndNumber',
              schema: {
                type: 'string',
                minLength: 1
              }
            }
          },
          type: 'VerticalLayout',
          elements: [
            {
              rule: {
                effect: 'HIDE',
                condition: {
                  scope: '#/properties/pesel',
                  schema: {
                    type: 'string',
                    minLength: 1
                  }
                }
              },
              type: 'Control',
              label: 'NIP',
              scope: '#/properties/nip',
              options: {
                showUnfocusedDescription: true
              }
            }
          ]
        },
        {
          rule: {
            effect: 'HIDE',
            condition: {
              scope: '#/properties/nip',
              schema: {
                type: 'string',
                minLength: 1
              }
            }
          },
          type: 'VerticalLayout',
          elements: [
            {
              rule: {
                effect: 'HIDE',
                condition: {
                  scope: '#/properties/pesel',
                  schema: {
                    type: 'string',
                    minLength: 1
                  }
                }
              },
              type: 'Control',
              label: 'Seria i numer dowodu osobistego/paszportu',
              scope: '#/properties/seriesAndNumber',
              options: {
                showUnfocusedDescription: true
              }
            }
          ]
        }
      ]
    },
    {
      type: 'Group',
      label: 'Adres zamieszkania',
      elements: [
        {
          type: 'HorizontalResponsive',
          elements: [
            {
              type: 'Control',
              label: 'Województwo',
              scope: '#/properties/voivodeship'
            },
            {
              type: 'Control',
              label: 'Miejscowość',
              scope: '#/properties/place'
            }
          ]
        },
        {
          type: 'HorizontalResponsive',
          elements: [
            {
              type: 'Control',
              label: 'Powiat',
              scope: '#/properties/county'
            },
            {
              type: 'Control',
              label: 'Ulica',
              scope: '#/properties/street'
            }
          ]
        },
        {
          type: 'HorizontalResponsive',
          elements: [
            {
              type: 'Control',
              label: 'Gmina',
              scope: '#/properties/commune'
            },
            {
              type: 'Control',
              label: 'Nr domu i nr mieszkania',
              scope: '#/properties/houseNumber'
            }
          ]
        },
        {
          type: 'HorizontalResponsive',
          elements: [
            {
              type: 'Control',
              label: 'Kod Pocztowy',
              scope: '#/properties/postcode'
            },
            {
              type: 'Control',
              label: 'Poczta',
              scope: '#/properties/postOffice'
            }
          ]
        }
      ]
    },
    {
      type: 'Group',
      label:
        'Adres zameldowania (wypełnić TYLKO jeżeli jest inny niż miejsce zamieszkania)',
      elements: [
        {
          type: 'HorizontalResponsive',
          elements: [
            {
              type: 'Control',
              label: 'Województwo',
              scope: '#/properties/registered_voivodeship'
            },
            {
              type: 'Control',
              label: 'Miejscowość',
              scope: '#/properties/registered_place'
            }
          ]
        },
        {
          type: 'HorizontalResponsive',
          elements: [
            {
              type: 'Control',
              label: 'Powiat',
              scope: '#/properties/registered_county'
            },
            {
              type: 'Control',
              label: 'Ulica',
              scope: '#/properties/registered_street'
            }
          ]
        },
        {
          type: 'HorizontalResponsive',
          elements: [
            {
              type: 'Control',
              label: 'Gmina',
              scope: '#/properties/registered_commune'
            },
            {
              type: 'Control',
              label: 'Nr domu i nr mieszkania',
              scope: '#/properties/registered_houseNumber'
            }
          ]
        },
        {
          type: 'HorizontalResponsive',
          elements: [
            {
              type: 'Control',
              label: 'Kod Pocztowy',
              scope: '#/properties/registered_postcode'
            },
            {
              type: 'Control',
              label: 'Poczta',
              scope: '#/properties/registered_postOffice'
            }
          ]
        }
      ]
    },
    {
      type: 'Group',
      label:
        'Adres do korespondencji (wypełnić TYLKO jeżeli jest inny niż miejsce zamieszkania)',
      elements: [
        {
          type: 'HorizontalResponsive',
          elements: [
            {
              type: 'Control',
              label: 'Województwo',
              scope: '#/properties/correspondence_voivodeship'
            },
            {
              type: 'Control',
              label: 'Miejscowość',
              scope: '#/properties/correspondence_place'
            }
          ]
        },
        {
          type: 'HorizontalResponsive',
          elements: [
            {
              type: 'Control',
              label: 'Powiat',
              scope: '#/properties/correspondence_county'
            },
            {
              type: 'Control',
              label: 'Ulica',
              scope: '#/properties/correspondence_street'
            }
          ]
        },
        {
          type: 'HorizontalResponsive',
          elements: [
            {
              type: 'Control',
              label: 'Gmina',
              scope: '#/properties/correspondence_commune'
            },
            {
              type: 'Control',
              label: 'Nr domu i nr mieszkania',
              scope: '#/properties/correspondence_houseNumber'
            }
          ]
        },
        {
          type: 'HorizontalResponsive',
          elements: [
            {
              type: 'Control',
              label: 'Kod Pocztowy',
              scope: '#/properties/correspondence_postcode'
            },
            {
              type: 'Control',
              label: 'Poczta',
              scope: '#/properties/correspondence_postOffice'
            }
          ]
        }
      ]
    },
    {
      type: 'Group',
      label: '',
      elements: [
        {
          type: 'Control',
          label: 'Nazwa banku',
          scope: '#/properties/bankName'
        },
        {
          type: 'Control',
          label: 'Właściciel konta',
          scope: '#/properties/accountOwner'
        },
        {
          type: 'Control',
          label: 'Numer konta',
          scope: '#/properties/accountNumber'
        }
      ]
    },
    {
      type: 'Group',
      label: 'Niniejszym oświadczam, że:',
      elements: [
        {
          type: 'Control',
          label:
            '1) Właściwym urzędem skarbowym dla mnie jest (nazwa i adres urzędu skarbowego)',
          scope: '#/properties/taxOffice',
          options: {
            showUnfocusedDescription: true
          }
        },
        {
          type: 'Control',
          label: '2) Właściwym dla mnie identyfikatorem podatkowym jest',
          scope: '#/properties/taxID'
        },
        {
          type: 'Control',
          label:
            '3) Właściwym Odziałem Narodwoego Funduszu Zdrowia dla mnie jest (nazwa)',
          scope: '#/properties/nationalHealthFund',
          options: {
            showUnfocusedDescription: true
          }
        },
        {
          type: 'Control',
          label: '4) Jestem emerytem',
          scope: '#/properties/retired'
        },
        {
          rule: {
            effect: 'SHOW',
            condition: {
              scope: '#/properties/retired',
              schema: {
                const: 'TAK'
              }
            }
          },
          type: 'Control',
          label: 'Numer świadczenia emerytalnego',
          scope: '#/properties/retiredNumber'
        },
        {
          type: 'Control',
          label: '5) Jestem rencistą',
          scope: '#/properties/pensioner'
        },
        {
          rule: {
            effect: 'SHOW',
            condition: {
              scope: '#/properties/pensioner',
              schema: {
                const: 'TAK'
              }
            }
          },
          type: 'Control',
          label: 'Numer świadczenia rentowego',
          scope: '#/properties/pensionerNumber'
        },
        {
          type: 'Control',
          label: '6) Orzeczenie o stopniu niepełnosprawności',
          scope: '#/properties/certificateDisability'
        },
        {
          rule: {
            effect: 'SHOW',
            condition: {
              scope: '#/properties/certificateDisability',
              schema: {
                const: 'Posiadam'
              }
            }
          },
          type: 'Control',
          label: 'Orzeczony stopień niepełnosprawności',
          scope: '#/properties/disabilityLevel'
        },
        {
          type: 'Control',
          label:
            '7) Jestem uczniem szkoły ponadpodstawowej albo studentem i nie ukończyłem 26 lat',
          scope: '#/properties/student',
          options: {
            showUnfocusedDescription: true
          }
        },
        {
          rule: {
            effect: 'SHOW',
            condition: {
              scope: '#/properties/student',
              schema: {
                const: 'TAK'
              }
            }
          },
          type: 'VerticalLayout',
          elements: [
            {
              type: 'Control',
              label: '',
              scope: '#/properties/studentType',
              options: {
                format: 'radio'
              }
            },
            {
              type: 'Control',
              label: 'Numer legitymacji',
              scope: '#/properties/cardNumber'
            },
            {
              type: 'HorizontalLayout',
              elements: [
                {
                  type: 'Control',
                  label: 'Legitymacja ważna od',
                  scope: '#/properties/cardFrom',
                  options: {
                    dateFormat: 'DD-MM-YYYY'
                  }
                },
                {
                  type: 'Control',
                  label: 'Legitymacja ważna do',
                  scope: '#/properties/cardTo',
                  options: {
                    dateFormat: 'DD-MM-YYYY'
                  }
                }
              ]
            },
            {
              type: 'Control',
              label:
                'Czy jesteś studentem ostatniego roku studiów pierwszego stopnia, drugiego stopnia lub jednolitych studiów magisterskich?',
              scope: '#/properties/studentLastYear'
            },
            {
              rule: {
                effect: 'SHOW',
                condition: {
                  scope: '#/properties/studentLastYear',
                  schema: {
                    const: 'Jestem'
                  }
                }
              },
              type: 'Control',
              label: 'Przewidywany termin utraty przeze mnie statusu studenta',
              scope: '#/properties/graduation',
              options: {
                dateFormat: 'DD-MM-YYYY'
              }
            }
          ]
        },
        {
          type: 'Control',
          label: '8) Pozostaję w rejestrze dla bezrobotnych',
          scope: '#/properties/unemployed'
        },
        {
          rule: {
            effect: 'SHOW',
            condition: {
              scope: '#/properties/unemployed',
              schema: {
                const: 'TAK'
              }
            }
          },
          type: 'Control',
          label: 'Wskazuję, że tym Urzędem Pracy jest',
          scope: '#/properties/laborOffice',
          options: {
            showUnfocusedDescription: true
          }
        },
        {
          type: 'Control',
          label: '9) Czy jesteś objęty ubezpieczeniem emerytalnym i rentowym ( z tytułu np. stosunku pracy, wykonywania usług w ramach umowy zlecenie, prowadzenie pozarolniczej działalności  lub z innego tytułu )',
          scope: '#/properties/retirementInsurance'
        },
        {
          rule: {
            effect: 'SHOW',
            condition: {
              scope: '#/properties/retirementInsurance',
              schema: {
                const: 'Jestem'
              }
            }
          },
          type: 'VerticalLayout',
          elements: [
            {
              text: 'Z tytułu:',
              type: 'Text',
              options: {
                varaint: 'subtitle1'
              }
            },
            {
              type: 'Control',
              label: 'Z tytułu:',
              scope: '#/properties/fromTitle'
            },
            {
              rule: {
                effect: 'SHOW',
                condition: {
                  scope: '#/properties/fromTitle',
                  schema: {
                    type: 'array',
                    contains: {
                      const: 'Stosunku pracy w innym zakładzie pracy'
                    }
                  }
                }
              },
              type: 'Group',
              elements: [
                {
                  text: 'stosunku pracy u innym zakładzie pracy w okresie czasu',
                  type: 'Text',
                  options: {
                    color: '#637381',
                    varaint: 'body2'
                  }
                },
                {
                  type: 'Control',
                  label: 'Czas nieokreślony',
                  scope: '#/properties/jobTimeIndefinite'
                },
                {
                  type: 'HorizontalLayout',
                  elements: [
                    {
                      type: 'Control',
                      label: 'Od',
                      scope: '#/properties/jobFrom',
                      options: {
                        custom: true,
                        dateFormat: 'DD-MM-YYYY'
                      }
                    },
                    {
                      rule: {
                        effect: 'HIDE',
                        condition: {
                          scope: '#/properties/jobTimeIndefinite',
                          schema: {
                            const: true
                          }
                        }
                      },
                      type: 'Control',
                      label: 'Do',
                      scope: '#/properties/jobTo',
                      options: {
                        custom: true,
                        dateFormat: 'DD-MM-YYYY'
                      }
                    }
                  ]
                }
              ]
            },
            {
              rule: {
                effect: 'SHOW',
                condition: {
                  scope: '#/properties/fromTitle',
                  schema: {
                    type: 'array',
                    contains: {
                      const: 'Wykonywania usług w ramach umów zlecenia'
                    }
                  }
                }
              },
              type: 'Group',
              elements: [
                {
                  text: 'wykonywania usług w ramach umów zlecenia w datach',
                  type: 'Text',
                  options: {
                    color: '#637381',
                    varaint: 'body2'
                  }
                },
                {
                  type: 'HorizontalLayout',
                  elements: [
                    {
                      type: 'Control',
                      label: 'Od',
                      scope: '#/properties/contractFrom',
                      options: {
                        custom: true,
                        dateFormat: 'DD-MM-YYYY'
                      }
                    },
                    {
                      type: 'Control',
                      label: 'Do',
                      scope: '#/properties/contractTo',
                      options: {
                        custom: true,
                        dateFormat: 'DD-MM-YYYY'
                      }
                    }
                  ]
                }
              ]
            },
            {
              rule: {
                effect: 'SHOW',
                condition: {
                  scope: '#/properties/fromTitle',
                  schema: {
                    type: 'array',
                    contains: {
                      const: 'Inny'
                    }
                  }
                }
              },
              type: 'Group',
              elements: [
                {
                  type: 'Control',
                  label: 'Z innego tytułu',
                  scope: '#/properties/otherReason'
                },
                {
                  type: 'HorizontalLayout',
                  elements: [
                    {
                      type: 'Control',
                      label: 'Od',
                      scope: '#/properties/otherFrom',
                      options: {
                        custom: true,
                        dateFormat: 'DD-MM-YYYY'
                      }
                    },
                    {
                      type: 'Control',
                      label: 'Do',
                      scope: '#/properties/otherTo',
                      options: {
                        custom: true,
                        dateFormat: 'DD-MM-YYYY'
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          rule: {
            effect: 'SHOW',
            condition: {
              scope: '#/properties/retirementInsurance',
              schema: {
                const: 'Jestem'
              }
            }
          },
          type: 'Control',
          label: '10) Dochód z tytułu ubezpieczenia emerytalnego i rentowego',
          scope: '#/properties/income',
          options: {
            showUnfocusedDescription: true
          }
        },
        {
          type: 'Control',
          label:
            '11) Czy pozostajesz na urlopach bezpłatnych, wychowawczych lub innych o podobnym charakterze?',
          scope: '#/properties/unpaidLeave'
        },
        {
          rule: {
            effect: 'SHOW',
            condition: {
              scope: '#/properties/unpaidLeave',
              schema: {
                const: 'Pozostaję'
              }
            }
          },
          type: 'Control',
          label: 'Rodzaj oraz okres urlopu',
          scope: '#/properties/vacation'
        }
      ]
    }
  ]
};
